module.exports = __webpack_public_path__ + "img/top_bg.cd938980.png";